import type { EntrySource } from './types';

import { ENTRY_SOURCE_KEY, SOURCE_RECORDING } from './constants';

export const getLocalEntrySource = (): EntrySource | null => {
  try {
    const raw = localStorage.getItem(ENTRY_SOURCE_KEY);
    if (raw === SOURCE_RECORDING) return 'recording';
    return null;
  } catch {
    return null;
  }
};

export const setLocalEntrySource = (source: EntrySource): void => {
  try {
    localStorage.setItem(ENTRY_SOURCE_KEY, source);
  } catch {
    /* no-op: storage unavailable */
  }
};

let pendingRecordingSignupEmail: null | string = null;

export const getRecordingEntrySourcePersistPending = (): boolean => pendingRecordingSignupEmail != null;

export const recordingEntrySourcePersistMatches = (email: null | string | undefined): boolean =>
  Boolean(email) && pendingRecordingSignupEmail === email;

export const setRecordingEntrySourcePersistPending = (email: string): void => {
  pendingRecordingSignupEmail = email;
};

export const clearLocalEntrySource = (): void => {
  try {
    localStorage.removeItem(ENTRY_SOURCE_KEY);
  } catch {
    /* no-op: storage unavailable */
  }
};

export const clearEntrySource = (): void => {
  pendingRecordingSignupEmail = null;
  try {
    localStorage.removeItem(ENTRY_SOURCE_KEY);
  } catch {
    /* no-op: storage unavailable */
  }
};
